import slugify from 'slugify'

export const StockTypeList: {
  name: string
  description: string
  seoTitle: string
  seoDescription: string
  link: string
  publiclink: string
  type: string
  icon?: string
  sortKey: string
  highToLow: boolean
  selectedCategoryId: number
  nativeAnchor: boolean
  keyword: string
  relativepath: string
  selected?: boolean
}[] = [
  {
    name: 'All Stocks',
    description:
      'Over 3000+ listed securities to explore with recommendations powered by IND’s proprietary model',
    seoTitle:
      'Explore All Stocks on  NSE and BSE (With Live share price and charts) | INDmoney',
    seoDescription:
      'Explore the list of stocks today on NSE & BSE. Analyze live data for all stocks with charts and in-depth market stats only on INDmoney',
    link: '/stocks/category/all',
    publiclink: 'stocks/category/all',
    type: 'all',
    sortKey: 'mCap',
    highToLow: true,
    selectedCategoryId: 0,
    nativeAnchor: false,
    keyword:
      'all stock markets, all markets, all markets watch, all stock markets today, market watch, all india stock markets, financial markets, commodity markets, indian markets live, equity markets,  markets trading, financial markets news',
    relativepath: '/stocks/category/all',
  },
  {
    name: 'Top Gainers',
    description:
      'Check out which stocks are gaining in today’s LIVE market with filters and sorting to help you explore',
    seoTitle:
      'Top Gainers Today NSE and BSE (With Live share price and charts) | INDmoney',
    seoDescription:
      'Check out the list of top gainers today in the stock market. Analyze 52 weeks top gainers live data for NSE and BSE stocks with charts and in-depth market stats only on INDmoney',
    link: '/stocks/category/top-gainers',
    publiclink: 'stocks/category/top-gainers',
    type: 'top_gainer_stock',
    sortKey: 'change',
    highToLow: true,
    icon: 'gainer.svg',
    selectedCategoryId: 0,
    nativeAnchor: false,
    keyword:
      'top gainers stock markets, top gainer markets, top gainer markets watch, top gainer stock markets today, top gainer market watch, top gainers india stock markets, financial markets, commodity markets, indian markets live, top gainer equity markets,  markets trading, financial markets news',
    relativepath: '/stocks/category/top-gainers',
  },
  {
    name: 'Top Losers',
    description:
      'Check out which stocks are losing in today’s LIVE market with filters and sorting to help you explore',
    seoTitle:
      'Top Losers Today NSE and BSE (With Live share price and charts) | INDmoney',
    seoDescription:
      'Check out the list of top losers today in the stock market. Analyze 52 weeks top losers  live data for NSE and BSE stocks with charts and in-depth market stats only on INDmoney',
    link: '/stocks/category/top-losers',
    publiclink: 'stocks/category/top-losers',
    type: 'top_loser_stock',
    sortKey: 'change',
    highToLow: false,
    icon: 'looser.svg',
    selectedCategoryId: 0,
    nativeAnchor: false,
    keyword:
      'top losers stock markets, top losers markets, top losers markets watch, top losers stock markets today, top losers market watch, top losers india stock markets, financial markets, commodity markets, indian markets live, top losers equity markets,  markets trading, financial markets news',
    relativepath: '/stocks/category/top-losers',
  },
  {
    name: 'Hot Stocks',
    description:
      'Check out most trending stocks with news and movement in the LIVE market today',
    seoTitle:
      'Hot Stocks Today NSE and BSE (With Live share price and charts) | INDmoney',
    seoDescription:
      'Check out the list of trending stocks today in the stock market. Analyze  live data for NSE and BSE  trending stocks with charts and in-depth market stats only on INDmoney',
    link: '/stocks/category/hot-stocks',
    publiclink: 'stocks/category/hot-stocks',
    type: 'hot_stock',
    sortKey: 'mCap',
    highToLow: true,
    icon: 'hotstock.svg',
    selectedCategoryId: 0,
    nativeAnchor: false,
    keyword:
      'hot stock markets, hot markets, hot markets watch, hot stock markets today, hot market watch, hot india stock markets, financial markets, commodity markets, indian markets live, hot equity markets,  markets trading, financial markets news',
    relativepath: '/stocks/category/hot-stocks',
  },
  {
    name: 'Most Active',
    description:
      'Check out stocks with the most activity, news and movement in the LIVE market today',
    seoTitle:
      'Top Active Today NSE and BSE (With Live share price and charts) | INDmoney',
    seoDescription:
      'Check out the list of high volume traded stocks today in the stock market. Analyze live data for NSE and BSE active stocks with charts and in-depth market stats only on INDmoney',
    link: '/stocks/category/most-active',
    publiclink: 'stocks/category/most-active',
    type: 'most_active_stock',
    sortKey: 'volume',
    highToLow: true,
    icon: 'mostactive.svg',
    selectedCategoryId: 0,
    nativeAnchor: false,
    keyword:
      'most active markets, most active markets, most active markets watch, most active stock markets today, most active market watch, most active india stock markets, financial markets, commodity markets, indian markets live,  markets trading, financial markets news',
    relativepath: '/stocks/category/most-active',
  },
  {
    name: 'At 52 Week High',
    description:
      'Check out stocks with the 52 week high prices, news and movement in the LIVE market today',
    seoTitle:
      '52 Week High Stocks Today NSE and BSE (With Live share price and charts) | INDmoney',
    seoDescription:
      'Explore the list of stocks that have touched their 52 week high (price) today on NSE & BSE. Analyze live data for 52 week high stocks with charts and in-depth market stats only on INDmoney',
    link: '/stocks/category/52-week-high',
    publiclink: 'stocks/category/52-week-high',
    type: 'high_stocks',
    sortKey: 'mCap',
    highToLow: true,
    icon: '52weekhigh.svg',
    selectedCategoryId: -1,
    nativeAnchor: false,
    keyword:
      '52 week high markets, 52 week high markets, 52 week high markets watch, 52 week high stock markets today, 52 week high market watch, 52 week high india stock markets, financial markets, commodity markets, indian markets live,  markets trading, financial markets news',
    relativepath: '/stocks/category/52-week-high',
  },
  {
    name: 'At 52 Week Low',
    description:
      'Check out stocks with the 52 week low prices, news and movement in the LIVE market today',
    seoTitle:
      '52 Week Low Stocks Today NSE and BSE (With Live share price and charts) | INDmoney',
    seoDescription:
      'Explore the list of stocks that have touched their 52 week low (price) today on NSE & BSE. Analyze live data for 52 week low stocks with charts and in-depth market stats only on INDmoney',
    link: '/stocks/category/52-week-low',
    publiclink: 'stocks/category/52-week-low',
    type: 'low_stocks',
    sortKey: 'mCap',
    highToLow: true,
    selectedCategoryId: -1,
    icon: '52weeklow.svg',
    nativeAnchor: false,
    keyword:
      '52 week low markets, 52 week low markets, 52 week low markets watch, 52 week low stock markets today, 52 week low market watch, 52 week low india stock markets, financial markets, commodity markets, indian markets live,  markets trading, financial markets news',
    relativepath: '/stocks/category/52-week-low',
  },
]

export const SortKeys = [
  {
    key: 'name',
    value: 'Name',
    subList: [
      {
        key: 'asc',
        value: 'A-Z',
      },
      {
        key: 'desc',
        value: 'Z-A',
      },
    ],
  },
  {
    key: 'price',
    value: 'Price',
    subList: [
      {
        key: 'desc',
        value: 'High - Low',
      },
      {
        key: 'asc',
        value: 'Low - High',
      },
    ],
  },
  {
    key: 'change',
    value: 'Change',
    subList: [
      {
        key: 'desc',
        value: 'High - Low',
      },
      {
        key: 'asc',
        value: 'Low - High',
      },
    ],
  },
  {
    key: 'volume',
    value: 'Volume',
    subList: [
      {
        key: 'desc',
        value: 'High - Low',
      },
      {
        key: 'asc',
        value: 'Low - High',
      },
    ],
  },
  {
    key: 'mCap',
    value: 'Market Cap',
    subList: [
      {
        key: 'desc',
        value: 'High - Low',
      },
      {
        key: 'asc',
        value: 'Low - High',
      },
    ],
  },
  {
    key: '1y_return',
    value: '1Y Return',
    subList: [
      {
        key: 'desc',
        value: 'High - Low',
      },
      {
        key: 'asc',
        value: 'Low - High',
      },
    ],
  },
  {
    key: '3y_return',
    value: '3Y Return',
    subList: [
      {
        key: 'desc',
        value: 'High - Low',
      },
      {
        key: 'asc',
        value: 'Low - High',
      },
    ],
  },
  {
    key: '5y_return',
    value: '5Y Return',
    subList: [
      {
        key: 'desc',
        value: 'High - Low',
      },
      {
        key: 'asc',
        value: 'Low - High',
      },
    ],
  },
]

export const generateDetailUrl = ({
  stock_name,
  company_code = '',
  link,
  params = '',
}: {
  stock_name: string
  company_code?: string
  params?: string
  link?: string
}) => {
  if (link) {
    return `${link}${params}`
  }
  return stock_name
    ? `/stocks/${slugify(
        stock_name.toLowerCase(),
      )}-share-price/${company_code}${params}`
    : ''
}

type TableColumn = {
  key: SortKeyType
  title: string
  customClassName?: string
}

// Enums for sort keys
export enum SortKeyType {
  NAME = 'name',
  PRICE = 'price',
  CHANGE = 'change',
  VOLUME = 'volume',
  MCAP = 'mCap',
  RETURN_1Y = '1y_return',
  RETURN_3Y = '3y_return',
  RETURN_5Y = '5y_return',
}

// Mapping from internal sort keys to API sort keys
export const SORT_KEY_MAP: Record<SortKeyType, string> = {
  [SortKeyType.NAME]: 'name',
  [SortKeyType.PRICE]: 'price',
  [SortKeyType.CHANGE]: 'change',
  [SortKeyType.VOLUME]: 'volume',
  [SortKeyType.MCAP]: 'mCap',
  [SortKeyType.RETURN_1Y]: '1y_return',
  [SortKeyType.RETURN_3Y]: '3y_return',
  [SortKeyType.RETURN_5Y]: '5y_return',
}

// Table column configuration
export const TABLE_COLUMNS: TableColumn[] = [
  { key: SortKeyType.NAME, title: 'Name', customClassName: '!justify-start' },
  { key: SortKeyType.PRICE, title: 'Price' },
  { key: SortKeyType.CHANGE, title: '1D Change' },
  { key: SortKeyType.VOLUME, title: 'Volume' },
  {
    key: SortKeyType.MCAP,
    title: 'Market Cap',
  },
  { key: SortKeyType.RETURN_1Y, title: '1Y' },
  { key: SortKeyType.RETURN_3Y, title: '3Y' },
  { key: SortKeyType.RETURN_5Y, title: '5Y' },
]
